// Module
var code = "<div class=\"authorize-message\"> <div ng-show=\"vm.loginBusy\"> {{vm.$scope.textLabels.AUTH0_AUTHENTICATION_IN_PROGRESS}} <div id=\"vm.loginBusy\" ng-style=\"{display: spinnerDisplay}\"><div class=\"spinner-round\"></div></div> </div> <div id=\"loginAlert\" class=\"message error\" ng-show=\"vm.showAlert\">{{vm.message}}</div> </div>";
// Exports
module.exports = code;